import { useState } from 'react';
import PropTypes from 'prop-types';
import { FilterListIcon } from 'src/components/assets/icons';
import {
  Popover,
  TableRow,
  TableCell,
  TableHead,
  Button,
  InputLabel,
  Checkbox,
  SearchIcon,
  CustomDateRangePicker,
  MenuItem,
  Select,
  Box,
  TextField,
  IconButton,
} from 'src/components/ui';
import { useGetRequests } from 'src/components/hooks';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSpinner } from 'src/components/hooks/useExtraStore';

const columns = [
  { id: 1, label: 'Nexudus UserId', property: 'nexudus_id' },
  { id: 2, label: 'Coworker', property: 'accountType' },
  { id: 4, label: 'Amount', property: 'itemAmount' },
  // { id: 3, label: 'Additional Service' },
  { id: 5, label: 'Status', property: 'status' },
  { id: 6, label: 'Category', property: 'categroyName' },
  { id: 7, label: 'Name', property: 'inventoryName' },
  { id: 8, label: 'Requested Date', property: 'requestedDate' },
  { id: 9, label: 'Last Seen', property: 'lastSeen' },
  // { id: 10, label: 'Purchased Item' },
  { id: 10, label: 'Purchase Date', property: 'purchaseDate' },
  { id: 11, label: 'Actions' },
];

export const RequestsHead = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchColumn, setSearchColumn] = useState('');
  const { getRequests } = useGetRequests();
  const { setSpinner } = useSpinner();

  const handleSearch = (e) => {
    setSpinner(true);
    const query = `${searchColumn}=${e}`;
    getRequests(0, 5, query);
  };

  return (
    <TableHead>
      <TableRow>
        {columns.map((headCell) => (
          <TableCell
            key={headCell.id}
            sx={{
              width: `${1600 / columns.length}px`,
            }}
          >
            {headCell.label !== 'Actions' && (
              <IconButton
                onClick={(e) => {
                  setAnchorEl(e.currentTarget);
                  setSearchColumn(headCell.property);
                }}
              >
                <FilterListIcon />
              </IconButton>
            )}
            <Box sx={{ height: 50 }}>{headCell.label}</Box>
          </TableCell>
        ))}

        <Popover
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
          }}
          transformOrigin={{
            vertical: 'top',
          }}
        >
          {(searchColumn === 'nexudus_id' ||
            searchColumn === 'itemAmount' ||
            searchColumn === 'inventoryName' ||
            searchColumn === 'categroyName') && (
            <Box
              sx={{
                bgcolor: 'background.paper',
                borderRadius: '14px',
                padding: '10px',
                display: 'flex',
                width: '300px',
              }}
            >
              <TextField
                autoFocus
                label={`Search ${searchColumn}`}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    height: '10px',
                  },
                }}
                sx={{ width: '100%' }}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <Box sx={{ marginLeft: '10px' }}>
                <IconButton
                  onClick={() => {
                    setAnchorEl(null);
                    getRequests(0, 5);
                  }}
                  size="small"
                >
                  <Box
                    sx={{
                      paddingInline: '10px',
                      paddingBlock: '6px',
                      background: 'red',
                      borderRadius: '8px',
                      color: 'white',
                    }}
                  >
                    x
                  </Box>
                </IconButton>
              </Box>
            </Box>
          )}

          {searchColumn === 'accountType' && (
            <Box sx={{ padding: '14px' }}>
              <Box sx={{ display: 'flex' }}>
                <Select
                  sx={{ width: '140px' }}
                  onChange={(e) => handleSearch(e.target.value)}
                  displayEmpty
                  renderValue={(selected) => {
                    return 'Account Type';
                  }}
                >
                  <MenuItem key="accountType1" value="1">
                    Personal
                  </MenuItem>
                  <MenuItem key="accountType2" value="2">
                    Company
                  </MenuItem>
                </Select>
                <Box sx={{ marginLeft: '10px' }}>
                  <IconButton
                    onClick={() => {
                      setAnchorEl(null);
                      getRequests(0, 5);
                    }}
                    size="small"
                  >
                    <Box
                      sx={{
                        paddingInline: '10px',
                        paddingBlock: '6px',
                        background: 'red',
                        borderRadius: '8px',
                        color: 'white',
                      }}
                    >
                      x
                    </Box>
                  </IconButton>
                </Box>
              </Box>
            </Box>
          )}

          {searchColumn === 'status' && (
            <Box sx={{ padding: '14px' }}>
              <Box sx={{ display: 'flex' }}>
                <Select
                  sx={{ width: '140px' }}
                  onChange={(e) => {
                    handleSearch(e.target.value);
                  }}
                  displayEmpty
                  renderValue={(selected) => {
                    return 'Status';
                  }}
                >
                  <MenuItem key="New" value="NEW">
                    New
                  </MenuItem>
                  <MenuItem key="Declined" value="DECLINED">
                    Declined
                  </MenuItem>
                  <MenuItem key="Approved" value="APPROVED">
                    Approved
                  </MenuItem>
                  <MenuItem key="Purchased" value="PURCHASED">
                    Purchased
                  </MenuItem>
                </Select>
                <Box sx={{ marginLeft: '10px' }}>
                  <IconButton
                    onClick={() => {
                      setAnchorEl(null);
                      getRequests(0, 5);
                    }}
                    size="small"
                  >
                    <Box
                      sx={{
                        paddingInline: '10px',
                        paddingBlock: '6px',
                        background: 'red',
                        borderRadius: '8px',
                        color: 'white',
                      }}
                    >
                      x
                    </Box>
                  </IconButton>
                </Box>
              </Box>
            </Box>
          )}

          {(searchColumn === 'requestedDate' ||
            searchColumn === 'lastSeen' ||
            searchColumn === 'purchaseDate') && (
            <Box sx={{ padding: '14px' }}>
              <Box sx={{ display: 'flex' }}>
                <DatePicker
                  label={`Select ${searchColumn}`}
                  onChange={(date) => {
                    if (date) {
                      const formattedDate = date.toLocaleDateString('en-CA');
                      handleSearch(formattedDate);
                    }
                  }}
                />
                <Box sx={{ marginLeft: '10px' }}>
                  <IconButton
                    onClick={() => {
                      setAnchorEl(null);
                      getRequests(0, 5);
                    }}
                    size="small"
                  >
                    <Box
                      sx={{
                        paddingInline: '10px',
                        paddingBlock: '6px',
                        background: 'red',
                        borderRadius: '8px',
                        color: 'white',
                      }}
                    >
                      x
                    </Box>
                  </IconButton>
                </Box>
              </Box>
            </Box>
          )}
        </Popover>
      </TableRow>
    </TableHead>
  );
};

RequestsHead.propTypes = {
  // handleSearch: PropTypes.func,
};
